import { render, staticRenderFns } from "./GoodsService.vue?vue&type=template&id=c4fc2234&"
import script from "./GoodsService.vue?vue&type=script&lang=ts&"
export * from "./GoodsService.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports